import { render, staticRenderFns } from "./vue-view-component.vue?vue&type=template&id=cddf7ad4"
import script from "./vue-view-component.vue?vue&type=script&lang=js"
export * from "./vue-view-component.vue?vue&type=script&lang=js"
import style0 from "./vue-view-component.vue?vue&type=style&index=0&id=cddf7ad4&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/graphileon/graphileon/release/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cddf7ad4')) {
      api.createRecord('cddf7ad4', component.options)
    } else {
      api.reload('cddf7ad4', component.options)
    }
    module.hot.accept("./vue-view-component.vue?vue&type=template&id=cddf7ad4", function () {
      api.rerender('cddf7ad4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue-view/vue-view-component.vue"
export default component.exports